/**
 * TM-1000001726 Phase 3: Frontend-Spiegel des Backend-Enums
 * {@code CrudFkResolutionEnum}. Bestimmt wie Fremdschluessel-Werte (FK)
 * aufgeloest werden.
 *
 * <ul>
 *   <li>{@code STRICT}         - FK wird ueber {@code findById} aufgeloest.
 *       Ist die Referenz nicht vorhanden, wird ein Fehler geworfen.</li>
 *   <li>{@code LENIENT}        - FK wird ueber {@code findById} aufgeloest.
 *       Bei fehlender Referenz wird {@code null} gesetzt.</li>
 *   <li>{@code REFERENCE_ONLY} - es wird nur die ID-Referenz gesetzt, KEIN
 *       Lookup gegen die Datenbank. Schnell, aber ohne Existenzpruefung.</li>
 * </ul>
 *
 * @ticket TM-1000001726
 */
export enum CrudFkResolutionEnum {
    STRICT,
    LENIENT,
    REFERENCE_ONLY
}
